/**
 * YouTube URLからVideoIdを抽出する
 * @param url
 * @returns VideoId または null
 */
export function extractYouTubeVideoId(
  url: string | null | undefined,
): string | null {
  if (!url) return null;

  const match = url.match(
    /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/,
  );
  return match ? match[1] : null;
}

/**
 * YouTube VideoIdからポスター画像URLを生成する
 * @param videoId
 * @returns ポスター画像URL または空文字
 */
export function getYoutubePoster(videoId: string | null): string {
  return videoId
    ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
    : '';
}
